export default {
  data() {
      return {
        windowWidth: '',
        windowHeight: ''
      }
  },

  created() {
      window.addEventListener('resize', this.handleResize)

      this.handleResize()
  },

  methods: {
      handleResize() {
        this.windowWidth = window.innerWidth
        this.windowHeight = window.innerHeight
    }
  },

  beforeDestroy() {
      window.removeEventListener('resize', this.handleResize)
  }
}